import { render, staticRenderFns } from "./padrones.vue?vue&type=template&id=cb6d937c&scoped=true&"
import script from "./padrones.vue?vue&type=script&lang=ts&"
export * from "./padrones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d937c",
  null
  
)

export default component.exports